import { createLogic } from 'redux-logic';

import { DeviceHandoffActionType } from '../state/constants';
import { persistDeviceHandoff } from '../state/persistence';
import type { DeviceHandoffRootState } from '../state/selectors';

const PERSISTED_ACTION_TYPES = Object.values(DeviceHandoffActionType).filter(
    (type) => type !== DeviceHandoffActionType.OVERWRITE_FROM_OTHER_TAB
);

const PersistDeviceHandoffLogic = createLogic<DeviceHandoffRootState>({
    type: PERSISTED_ACTION_TYPES,
    process({ getState }, _dispatch, done): void {
        persistDeviceHandoff(getState().deviceHandoff);
        done();
    },
});

export const deviceHandoffPersistenceLogic = [PersistDeviceHandoffLogic];
